export const newsPages = '/aktualnosci';
export const announcementsPages = '/ogloszenia';
export const registrationPage = '/rejestracja';
export const foreignRegistrationPage = '/rejestracja-zagranica';
export const loginPage = '/login';
export const passwordResetPage = '/reset';
export const confirmAccountPage = '/potwierdzenie-konta';
export const panelPage = '/panel';
export const districtsPage = panelPage + '/okregi';
export const schoolsPage = panelPage + '/szkoly';
export const teachersPage = panelPage + '/nauczyciele';
export const studentsPage = panelPage + '/uczniowie';
export const olympicsStagesPage = panelPage + '/etapy';
export const olympicsSettingsPage = panelPage + '/ustawienia';
export const emailCampaignsPage = panelPage + '/wysylki';
export const managementPage = panelPage + '/zarzadzanie';
export const whatsNewPage = panelPage + '/co-nowego';
export const helpPage = panelPage + '/pomoc';
export const accountPage = '/konto';
